import CharacterSvg from './Character.png';
import styles from './Character.module.css';

function Character() {
    return (
        <div className={styles.layout}>
            <img 
            className={styles.image}
            src={CharacterSvg} 
            alt="AVA" 
            />
        </div> 
    );
}

export default Character;